import React from 'react'
import { PiMagnifyingGlass } from 'react-icons/pi'
import { BiError } from 'react-icons/bi'

interface MobileSearchEmptyStateProps {
  type: 'no-query' | 'no-results' | 'error'
  query?: string
  errorMessage?: string
}

export const MobileSearchEmptyState: React.FC<MobileSearchEmptyStateProps> = ({
  type,
  query,
  errorMessage,
}) => {
  if (type === 'no-query') {
    return (
      <div className="flex flex-col items-center justify-center p-12 px-6 text-center text-new-company-gray-500">
        <div className="text-5xl mb-4 opacity-50">
          <PiMagnifyingGlass />
        </div>
        <div className="text-base mb-2">Start typing to search</div>
      </div>
    )
  }

  if (type === 'no-results') {
    return (
      <div className="flex flex-col items-center justify-center p-12 px-6 text-center text-new-company-gray-500">
        <div className="text-5xl mb-4 opacity-50">
          <PiMagnifyingGlass />
        </div>
        <div className="text-base mb-2">No results found</div>
        <div className="text-sm text-new-company-gray-500">
          {query
            ? `No results found for "${query}"`
            : 'Try a different search term'}
        </div>
      </div>
    )
  }

  if (type === 'error') {
    return (
      <div className="flex flex-col items-center justify-center p-12 px-6 text-center text-new-company-gray-500">
        <div className="text-5xl mb-4 opacity-50">
          <BiError />
        </div>
        <div className="text-base mb-2">Something went wrong</div>
        <div className="text-sm text-new-company-gray-500">
          {errorMessage || 'Please try again later'}
        </div>
      </div>
    )
  }

  return null
}
